import {Form as StyledForm} from './styles';
import {FormProps} from './types';

const Form: React.FC<FormProps> = (props) => <StyledForm {...props} />;

export default Form;
